import { type AlertButton } from "react-native";

import Swal from "sweetalert2";
import "./alert.css";

class Alert {
  static alert(title: string, message?: string, buttons?: AlertButton[]): void {
    const confirmButton = buttons
      ? buttons.find((button) => button.style === "default")
      : undefined;
    const denyButton = buttons
      ? buttons.find((button) => button.style === "destructive")
      : undefined;
    const cancelButton = buttons
      ? buttons.find((button) => button.style === "cancel")
      : undefined;

    // Fallback: if no buttons are provided or found, show a default OK button
    const hasAnyButton = confirmButton || denyButton || cancelButton;
    const showDefaultOK = !buttons || !hasAnyButton;

    Swal.fire({
      title: title,
      text: message,
      backdrop: false,
      allowOutsideClick: true,
      allowEscapeKey: true,
      showConfirmButton: !!confirmButton || showDefaultOK,
      showDenyButton: !!denyButton,
      showCancelButton: !!cancelButton,
      confirmButtonText:
        confirmButton?.text || (showDefaultOK ? "OK" : undefined),
      denyButtonText: denyButton?.text,
      cancelButtonText: cancelButton?.text,
    })
      .then((result) => {
        if (result.isConfirmed) {
          if (confirmButton?.onPress !== undefined) {
            confirmButton.onPress();
          }
        } else if (result.isDenied) {
          if (denyButton?.onPress !== undefined) {
            denyButton.onPress();
          }
        } else if (result.isDismissed) {
          if (cancelButton?.onPress !== undefined) {
            cancelButton.onPress();
          }
        }
      })
      .catch((error) => {
        console.error("::Alert - error", error);
      });
  }
}

export default Alert;
